import { render, staticRenderFns } from "./ConfirmColleges.vue?vue&type=template&id=32fb3b35&scoped=true"
import script from "./ConfirmColleges.vue?vue&type=script&lang=js"
export * from "./ConfirmColleges.vue?vue&type=script&lang=js"
import style0 from "./ConfirmColleges.vue?vue&type=style&index=0&id=32fb3b35&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "32fb3b35",
  null
  
)

export default component.exports